import React, { useState, useEffect } from "react";
import { formatDate4, formatDate5, getOrDeleteRequest, getSession } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import MainThemeLayout from "../../layout/MainThemeLayout";
import DataTableComponent from "../../components/DataTableComponent";
import SelectMultiple from "../../components/SelectMultiple";

const Companies = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [projects, setProjects] = useState([]);
    const [idProject, setIdProject] = useState(null);

    const getCompanies = async (page = 1, project_id) => {
        setLoading(true);
        setData([]);
        let response = await getOrDeleteRequest(
            `company/index?page=${page}${(project_id) ? `&project_id=${project_id}` : ''}`,
            'GET',
        );

        if (response.type === 'success') {
            setData(response.data);
        } else {
            setData([]);
        }
        setLoading(false);
    };

    const getProjects = async () => {
        let session = getSession();

        let uri;

        if ([1, 6].includes(session.type_id)) {
            uri = `projects/filter`;
        }

        if ([4, 5].includes(session.type_id)) {
            uri = `projects/projectbycompany/${session.company.id}`;
        }

        let response = await getOrDeleteRequest(
            uri,
            'GET',
        );

        // console.log(response, "response projects");

        if (response.type === 'success') {
            setProjects([
                {
                    name: "Todos los proyectos",
                    id: null
                },
                ...response.data.map((project) => ({
                    name: project.name,
                    id: project.id
                }))
            ]);
        }
    };

    const columns = [
        {
            name: 'Empresa o entidad',
            selector: (row) => row.company_name,
        },
        {
            name: 'Razón social',
            selector: (row) => row.trade_name ?? 'No especificado',
        },
        {
            name: 'Dirección',
            selector: (row) => row.address ?? 'No especificado',
        },
        {
            name: 'Nombre de persona de contacto',
            selector: (row) => row.contact_name ?? 'Sin nombre de contacto',
        },
        {
            name: 'Número de contacto',
            selector: (row) => row.contact_phone ?? 'Sin número de contacto',
        },
        {
            name: 'Fecha de creación',
            selector: (row) => formatDate4(row.created_at),
        },
        {
            name: 'Fecha de actualización',
            selector: (row) => formatDate4(row.updated_at),
        },
        {
            name: 'Tipo de empresa o entidad',
            selector: (row) => {
                return row.company_types.length > 0 ? row.company_types[0].name : "Sin tipo";
            },
        },
        {
            name: 'Estado',
            width: '200px',
            selector: (row) => row.status === 1 ? "Activo" : "Inactivo"
        },
    ];

    const allFunctions = async () => {
        await getCompanies(1);
        await getProjects();
        setLoading(false);
    }

    useEffect(() => {
        allFunctions();
    }, []);

    return (
        <MainThemeLayout>
            <div className="px-8 py-6">
                <div className="mb-4">

                    <h1 className="text-xl font-semibold text-stone-800 dark:text-white mb-2">
                        Empresas o entidades
                    </h1>
                    <p className="text-sm text-stone-500 dark:text-white">
                        Listado de Empresas o entidades registradas en la plataforma.
                    </p>
                </div>
                <div className="w-full mt-4">
                    <SelectMultiple
                        name="projects"
                        loading={loading}
                        array={projects}
                        label="Empresas o entidades por proyecto"
                        isMulti={false}
                        alert={alert}
                        value={idProject}
                        onChange={(e) => {
                            if (e) {
                                setIdProject(e)
                                getCompanies(1, e);
                            } else {
                                setIdProject(null);
                                getCompanies(1);
                            }
                        }}
                        placeholder="Seleccione un proyecto"
                    />
                </div>
                <div>
                    <DataTableComponent
                        nameTable={'Organizaciones'}
                        data={data}
                        columns={columns}
                        setLoading={setLoading}
                        loading={loading}
                        toView="/VerPerfilOrg/"
                        toEdit="/Organizaciones/Editar/"
                        // toDisable="company/disable/"
                        // toEnable="company/enable/"
                        toDelete="company/destroy/"
                        reload={getCompanies}
                        button={
                            <Link to={"/Organizaciones/Agregar"} className="bg-turquesa hover:opacity-90 rounded-lg px-4 py-2 text-sm text-white cursor-pointer">
                                Agregar
                            </Link>
                        }
                    />
                </div>
            </div>
        </MainThemeLayout>
    );
};

export default Companies;
